import Box from '@mui/material/Box';
import Slide from '@mui/material/Grow';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Button from 'components/Button/Button';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Answer } from '../AnswersPreview';
import ErrorModal from '../ErrorModal';
import Progress from '../Progress';
import Field from './Field';
import { useForm } from './Form';

const Footer = styled(Stack)`
  position: relative;
  bottom: 0;
  right: 0;
  button {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

const MultiStepForm = ({
  questions,
  currentIndex,
  setStep,
  onPrev,
  isLast,
  account,
  onQuestionChange,
}) => {
  const form = useForm();
  const [error, setError] = useState(null);
  const selectedQuestion = questions[currentIndex];
  const totalSteps = questions.length;
  const answers = useSelector((s) => s.form);

  const onNext = () => {
    return form
      .validateFields()
      .then((values) => {
        const emailField = questions.find((i) => i.is_email_address === '1');
        const phoneField = questions.find((i) => i.is_mobile === '1');
        const requiredFields = form.getFieldsValue([
          emailField.hash,
          phoneField.hash,
        ]);
        const prevField = questions[currentIndex - 1];
        if (prevField) {
          if (
            (prevField.is_mobile === '1' ||
              prevField.is_email_address === '1') &&
            !Object.values(requiredFields).some((i) => i)
          ) {
            return setError('Email or phone is required');
          }
        }
        return setStep();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <Box>
        {questions.map((question, index) => {
          if (selectedQuestion.id === question.id) {
            return (
              <Slide in key={index} direction="up" mountOnEnter unmountOnExit>
                <Box mb={1}>
                  <Field
                    autoFocus
                    field={selectedQuestion}
                    key={selectedQuestion.id}
                    account={account}
                  />
                </Box>
              </Slide>
            );
          }
          return (
            <Answer
              question={question}
              answer={answers[question.hash]}
              index={index}
              onSelect={onQuestionChange}
              key={index}
            />
          );
        })}
      </Box>
      <Footer spacing={2} direction="row" pt={2}>
        <Button fullWidth size="large" onClick={onNext}>
          {isLast ? 'Submit' : 'Next'}
        </Button>
      </Footer>
      <Progress current={currentIndex} total={totalSteps} />
      {error && <ErrorModal message={error} onClose={() => setError()} />}
    </>
  );
};

export default MultiStepForm;
